import L from "leaflet";
import "../../extensions/leaflet-corridor"
import {createWaypointMarker, refreshWaypointTooltips} from "@/my-leaf/routes/components/route-waypoints";
import { GeoUtils } from "@/utils/geo-utils";
import { WaypointUtils } from "@/utils/waypoint-utils";

export function clearLegs() {
    this.legsGroup.clearLayers()
}

function drawCorridor(waypoints) {
    let width = this.routesStore.getShipXTE

    const options = {
        corridor: width,
        opacity: 0.3,
        interactive: false,
        color: 'white',
        isCorridor: true
    };

    let wpList = []

    waypoints.forEach(waypoint => {
        wpList.push(waypoint.getLatLng())
    })
    L.corridor(wpList, options).addTo(this.legsGroup).bringToBack();
}

export function drawLegs(config) {
    const { updateRouteTable = true, makeRouteTable = true } = config ?? {};

    clearLegs.call(this);

    this.offsetWaypoints.map((waypoints, offsetIndex) => {
        // HACK for now. each WP is not a data objects, but actual map item.

        if (offsetIndex != 1)
        {
            // replicate waypoints in legs layer for -360, 360
            waypoints.forEach((wp, index) => {
                const replicatedWP = createWaypointMarker.call(
                    this,
                    {
                        coordinates: wp.getLatLng(),
                        id: wp.options.id,
                        uid: wp.options.uid,
                        color: wp.options.color,
                        isSelected: wp.options.isSelected
                    }
                )
                replicatedWP.addTo(this.legsGroup);

                refreshWaypointTooltips(replicatedWP, index, waypoints.length);
            })
        }
        
        if (waypoints.length > 1) {
            let lines1 = []
            let lines2 = []
            let wpList = []
            let dangersList = []
            let dangersListUids = [];

            let isDangerLeg = false

            waypoints.forEach((waypoint, index) => {
                wpList.push(waypoint.getLatLng())
            })

            drawCorridor.call(this, waypoints)
        
            const routeLines = WaypointUtils.drawSegments(wpList);
            routeLines.forEach((l, sidx) => {
                l.options.uids = [
                    waypoints[sidx].options.uid,
                    waypoints[sidx + 1].options.uid,
                ];
                l.addTo(this.legsGroup);
            });

            waypoints.forEach((waypoint, index) => {
                let safety = this.routesStore.getShipLegSafety(index)
                if (!safety) {
                    dangersList.push(waypoint.getLatLng())
                    dangersListUids.push(waypoint.options.uid);
                } else {
                    if (dangersList.length > 0) {
                        dangersList.push(waypoint.getLatLng())
                        let routeLine = L.polyline(dangersList, {
                            color: 'red',
                            weight: 2,
                            clickable: false,
                            interactive: false,
                            uids: dangersListUids
                        }).addTo(this.legsGroup);

                        dangersList = [];
                        dangersListUids = [];
                    }
                }
            })

            waypoints.forEach(waypoint => {
                waypoint.bringToFront()
            })
        }
    });

    if (this.waypoints.length > 1) {
        this.initTooltips()
    }

    if (makeRouteTable)
        this.makeRouteTable(updateRouteTable)
}

// TODO: this is not used yet, but might be if performance degrades
export function updateLegs(updatedUids, newUids) {
    let redrawPointUids = [
        ...(updatedUids ?? []),
        ...(newUids ?? [])
    ];
    let redrawLegsUids = [];

    if (newUids?.length) {
        this.offsetWaypoints.map((waypoints, offsetIndex) => {
            newUids.forEach(uid => {
                const wpIndex = this.waypoints.findIndex(wp => wp.options.uid == uid);
                if (wpIndex == 0) {
                    redrawLegsUids.push([wpIndex, wpIndex + 1]);
                }
                else if (wpIndex == this.waypoints.length - 1) {
                    redrawLegsUids.push([wpIndex - 1, wpIndex]);
                }
                else {
                    redrawLegsUids.push([wpIndex - 1, wpIndex]);
                    redrawLegsUids.push([wpIndex, wpIndex + 1]);
                }
            }) 
        });
    }

    if (updatedUids?.length) {
        this.legsGroup.getLayers().forEach(l => {
            if (l.options?.uid && updatedUids.includes(l.options.uid)) {
                this.legsGroup.removeLayer(l);
            }

            if (l.options?.uids && updatedUids.some(uid => l.options.uids.includes(uid))) {
                this.legsGroup.removeLayer(l);
                if (!redrawLegsUids.some(p => p[0] == l.options.uids[0] && p[1] == l.options.uids[1] ))
                    redrawLegsUids.push(l.options.uids);
            }

            if (l.options.isCorridor) {
                this.legsGroup.removeLayer(l);
            }
        })
    }

    this.offsetWaypoints.map((waypoints, offsetIndex) => {
        if (offsetIndex != 1)
        {
            // replicate waypoints in legs layer for -360, 360
            waypoints.filter(wp => redrawPointUids.includes(wp.options.uid)).forEach((wp, index) => {
                const replicatedWP = createWaypointMarker.call(
                    this,
                    {
                        coordinates: wp.getLatLng(),
                        id: wp.options.id,
                        uid: wp.options.uid,
                        color: wp.options.color,
                        isSelected: wp.options.isSelected
                    }
                )
                replicatedWP.addTo(this.legsGroup);

                refreshWaypointTooltips(replicatedWP, index, waypoints.length);
            })
        }

        redrawLegsUids.forEach(uids => {
            const legWaypoints = uids.map(uid => waypoints.find(wp => wp.options.uid == uid));
            if (!legWaypoints.every(Boolean)) return;
            const wpList = legWaypoints.map(wp => wp.getLatLng());

            const routeLines = WaypointUtils.drawSegments(wpList);
            routeLines.forEach(l => {
                l.options.uids = uids;
                l.addTo(this.legsGroup);
            });
        })

        drawCorridor.call(this, waypoints);
    });

    this.makeRouteTable(true);
}